import React from 'react';
import { useDisclosure } from '@withjoy/joykit';

import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import CurrencySelectorModal, { CurrencySelectorTrigger } from './CurrencySelectorModal';

export const CurrencySelector: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isCurrencySelectorEnabled] = useIsFeatureEnabled('travelGuestCurrencySwitch');

  if (!isCurrencySelectorEnabled) return null;

  const handleTriggerClick = () => {
    if (isOpen) {
      onClose();
    } else {
      onOpen();
    }
  };

  return (
    <CurrencySelectorModal
      isOpen={isOpen}
      onClose={onClose}
      trigger={
        <CurrencySelectorTrigger
          isOpen={isOpen}
          onClick={handleTriggerClick}
        />
      }
    />
  );
};
